export default __webpack_public_path__ + "static/media/location-drop-pin.inline.37e95f03.svg";